"use client";
import { useTranslation } from "@/lib/i18n";
import type { Language } from "@/lib/schema/sections";
import { useResumeStore } from "@/lib/store/resume";
import { Button, Input, Select, SelectItem } from "@nextui-org/react";
import { produce } from "immer";
import { BookA } from "lucide-react";
import { useState } from "react";
import Base from "./shared/Base";

export const LevelMap: Record<string, number> = {
  basic: 1,
  competent: 2,
  skilled: 3,
  advanced: 4,
  expert: 5,
};

const AccordionItemContent = (props: Language) => {
  const { id, level = "basic", name, description } = props;
  const [result, setResult] = useState(props);
  const { t } = useTranslation({ ns: "resume-sidebar" });
  const { setValue, resume } = useResumeStore();
  const sections = resume.data.sections;
  const items = sections?.languages?.items;

  const handleSave = () => {
    setValue(
      `sections.languages.items`,
      produce(items as unknown as string, (draft: any[]): void => {
        const index = draft.findIndex((item) => item.id === id);
        if (index === -1) return;
        draft[index] = result;
      }),
    );
  };

  return (
    <>
      <div className="flex justify-between gap-4">
        <Input
          onBlur={handleSave}
          size="sm"
          type="name"
          label={t("left.languages.name")}
          defaultValue={name}
          onValueChange={(value) => setResult({ ...result, name: value })}
        />
        <Input
          onBlur={handleSave}
          size="sm"
          type="description"
          label={t("left.languages.description")}
          defaultValue={description}
          onValueChange={(value) =>
            setResult({ ...result, description: value })
          }
        />
      </div>
      <div className="mt-4 flex justify-between gap-4">
        <Select
          onVolumeChange={handleSave}
          label={t("left.languages.level")}
          className="max-w-xs"
          size="sm"
          defaultSelectedKeys={[`${level}`]}
          onChange={(e) => {
            setResult({ ...result, level: e.target.value });
            setValue(
              `sections.languages.items`,
              produce(items as unknown as string, (draft: any[]): void => {
                const index = draft.findIndex((item) => item.id === id);
                if (index === -1) return;
                draft[index] = { ...result, level: e.target.value };
              }),
            );
          }}
        >
          {["basic", "competent", "skilled", "advanced", "expert"].map(
            (item) => (
              <SelectItem key={item} value={item}>
                {t(`left.languages.level.${item}`)}
              </SelectItem>
            ),
          )}
        </Select>
      </div>

      <div className="flex justify-end">
        <Button
          radius="sm"
          size="sm"
          className="mt-2"
          variant="ghost"
          onClick={handleSave}
        >
          {t("left.save")}
        </Button>
      </div>
    </>
  );
};

const Languages = () => {
  const { t } = useTranslation({ ns: "resume-sidebar" });

  return (
    <Base
      id="languages"
      title={t("left.languages.name")}
      itemTitle={"name"}
      ItemContent={AccordionItemContent}
      icon={<BookA size={20} />}
    />
  );
};

export default Languages;
